import { createCreateExpenseValidator, createExpenseSplitValidator, createUpdateExpenseValidator, } from "#validators/expenses.validator.factory";
// Use factory functions with pass-through translation for type inference
const expenseSplitValidatorForType = createExpenseSplitValidator((key) => key);
const createExpenseValidatorForType = createCreateExpenseValidator((key) => key);
const updateExpenseValidatorForType = createUpdateExpenseValidator((key) => key);
